<template>
  <v-btn rounded="pill" class="bookmark-btn" @click="bookmarkSmartfile">
    <v-icon class="bookmark-icon">fa-{{ isSmartFileBookmarked ? "solid" : "light" }} fa-bookmark</v-icon>
    <span class="bookmark-text d-none d-md-inline">Atzīmēt tēmu</span>
  </v-btn>
</template>

<script lang="ts">
import { useSmartPageStore } from "~/stores/smartPageStore"

export default {
  setup() {
    const smartPageStore = useSmartPageStore()
    return { smartPageStore }
  },

  data() {
    return {
      isSmartFileBookmarked: false,
    }
  },

  computed: {
    bookmarkingParams() {
      return {
        identifier: (this.smartPageStore.value.smartFile as any).id,
        type: "SmartFile",
      }
    },
  },

  watch: {
    "smartPageStore.value.smartFile.id"() {
      this.checkIfPageBookmarked()
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.checkIfPageBookmarked()
    })
  },

  methods: {
    checkIfPageBookmarked() {
      this.smartPageStore.checkBookmarked({
        params: this.bookmarkingParams,
        successCallback: (ctx) => {
          this.isSmartFileBookmarked = ctx.response._data.favourite
        },
      })
    },

    bookmarkSmartfile() {
      if (this.isSmartFileBookmarked) {
        this.smartPageStore.removeBookmark({ params: this.bookmarkingParams, successCallback: this.bookmarkUnchecked })
      } else {
        this.smartPageStore.bookmarkPage({ params: this.bookmarkingParams, successCallback: this.bookmarkChecked })
      }
    },

    bookmarkChecked() {
      this.isSmartFileBookmarked = true
    },

    bookmarkUnchecked() {
      this.isSmartFileBookmarked = false
    },
  },
}
</script>

<style lang="sass">
.bookmark-btn
  text-transform: none
  letter-spacing: 0.1px
  font-weight: 400
  font-size: 16px
  line-height: 20px
  min-width: 0

.bookmark-icon
  margin-right: 12px
</style>
